export default "__VITE_ASSET__DTQGcyZa__"